export enum TagType {
    BranchOffice
}

export const TagTypeValues: { [id: number]: string } = {
    0: 'Sucursal'
  };
  
  export namespace TagType {
    export function values() {
      let values = Object.keys(TagType)
        .filter((type) => isNaN(<any>type) && type !== 'values')
        .map((key, index) => {
          return { key: TagTypeValues[index], value: index };
        });
      return values.filter((x) => x.value != 0);
    }
  }
  